(() => {
  const initialize = world => {
    if (world.dataset.hwReady) return;
    world.dataset.hwReady = 'true';
    const config = JSON.parse(world.querySelector('[data-hw-config]').textContent);
    const cards = [...world.querySelectorAll('[data-hw-product]')];
    let format = 'all';
    let flavour = 'all';
    let toastTimer;
    const filter = () => {
      let count = 0;
      cards.forEach(card => {
        card.hidden = !((format === 'all' || card.dataset.kind === format) && (flavour === 'all' || card.dataset.flavour === flavour));
        if (!card.hidden) count++;
      });
      world.querySelector('[data-hw-count]').textContent = config.count.replace('__COUNT__', count);
      world.querySelector('[data-hw-empty]').hidden = count !== 0;
      world.querySelector('[data-hw-clear]').hidden = flavour === 'all';
      world.querySelectorAll('[data-hw-format]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hwFormat === format)));
      world.querySelectorAll('[data-hw-potion]').forEach(button => button.classList.toggle('is-selected', button.dataset.hwPotion === flavour));
    };
    world.querySelectorAll('[data-hw-format]').forEach(button => button.addEventListener('click', () => { format = button.dataset.hwFormat; filter(); }));
    world.querySelectorAll('[data-hw-potion]').forEach(button => button.addEventListener('click', () => { flavour = button.dataset.hwPotion; format = 'all'; filter(); }));
    world.querySelector('[data-hw-clear]').addEventListener('click', () => { flavour = 'all'; filter(); });
    world.querySelectorAll('[data-hw-variant]').forEach(select => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const card = select.closest('[data-hw-product]');
      card.querySelector('[data-hw-price]').textContent = option.dataset.price;
      const button = card.querySelector('[data-hw-add]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? config.soldOut : config.add;
      card.querySelector('[data-hw-status]').textContent = '';
    }));
    world.querySelectorAll('.hw-product-form').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('[data-hw-add]');
      if (button.disabled) return;
      const status = form.querySelector('[data-hw-status]');
      button.disabled = true;
      button.textContent = config.adding;
      status.textContent = '';
      try {
        const response = await fetch(world.dataset.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || config.error);
        status.textContent = config.added;
        const toast = world.querySelector('[data-hw-toast]');
        world.querySelector('[data-hw-toast-text]').textContent = config.added;
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => { toast.hidden = true; }, 6500);
        fetch(`${world.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(r => r.json()).then(cart => {
          document.querySelectorAll('[data-header-cart-count]').forEach(counter => { counter.textContent = cart.item_count; });
        }).catch(() => {});
      } catch (error) {
        status.textContent = error.message || config.error;
      } finally {
        button.disabled = false;
        button.textContent = config.add;
      }
    }));
  };
  document.querySelectorAll('[data-hw-world]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hw-world]').forEach(initialize));
})();
